<div [ngClass]="{ 'restrict-height': restrictHeight }">
  <div class="modal-header">
    <div class="modal-title pull-left">
      <hb-text-modal-title [text]="heading"></hb-text-modal-title>
      <hb-text-subtitle [text]="subHeading"></hb-text-subtitle>
    </div>
    <button type="button" class="close pull-right" (click)="close()">
      <i aria-hidden="true" class="fa fa-times"></i>
    </button>
  </div>

  <div [class]="noOverflow ? 'modal-body-no-overflow' : 'modal-body'">
    <ng-content select="[content]"></ng-content>
  </div>

  <div *ngIf="showFooter" class="modal-footer">
    <button [id]="okBtnId ? okBtnId : 'modal-dialog-ok'" type="button" class="btn btn-primary" [title]="'ModalDialog.Ok' | i18next" [disabled]="okDisabled" (click)="okClick($event)">
      {{ 'ModalDialog.Ok' | i18next }}
    </button>
    <button
      id="modal-dialog-cancel"
      *ngIf="showCancel"
      [title]="'ModalDialog.Cancel' | i18next"
      type="button"
      class="btn btn-default pull-right"
      (click)="close()"
    >
      {{ 'ModalDialog.Cancel' | i18next }}
    </button>
  </div>

  <!-- There are enough places with custom footer code to justify allowing a custom footer to be specified -->
  <div [hidden]="hideOptionalFooter" #optionalFooter class="modal-footer">
    <ng-content select="[footerContent]"></ng-content>
  </div>
</div>
